module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 5
// module chunks = 75